import React from 'react'
import { useAppContext } from '../../../context/appContext';
import { TextMd, TextSm } from '../../../components/text';
import { SeeMore } from '../../home/components/seeMore';

export const FullStackApplications = ({ className="" }) => {
  const { routing } = useAppContext();
  const { navigate } = routing;

  return (
    <button
      className={`flex w-full flex-col items-center gap-8 text-left ${className}`}
    >
      <div className="w-full flex flex-col">
        <TextSm className="uppercase whitespace-nowrap tracking-[0.1em] text-blue-500 font-semibold">
          Full Stack Applications
        </TextSm>

        <TextMd className="font-semibold text-slate-900 mb-4">
          Building complete applications from interface to infrastructure.
        </TextMd>

        <TextSm className="text-slate-500 leading-7 mb-8">
          Full stack development combining modern frontend interfaces with
          reliable backend systems, creating applications that are easy to
          use, maintain, and scale.
        </TextSm>

        <div className="flex flex-wrap gap-x-8 gap-y-3">
          <div className="flex items-center gap-3 text-slate-700">
            <div className="h-1.5 w-1.5 rounded-full bg-blue-500" />
            <TextSm>React Interfaces</TextSm>
          </div>

          <div className="flex items-center gap-3 text-slate-700">
            <div className="h-1.5 w-1.5 rounded-full bg-blue-500" />
            <TextSm>Backend Logic</TextSm>
          </div>

          <div className="flex items-center gap-3 text-slate-700">
            <div className="h-1.5 w-1.5 rounded-full bg-blue-500" />
            <TextSm>Database Integration</TextSm>
          </div>
        </div>
      </div>
    </button>
  )
}
